import { render } from "./app_version.vue?vue&type=template&id=10e0a5b0"
import script from "./app_version.vue?vue&type=script&lang=js"
export * from "./app_version.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__